module.exports = __webpack_public_path__ + "img/0-94.478c4d08.jpg";